import { renderFormattedDate } from "../helpers/FormatDate";
import { renderPerformanceLink } from "../helpers/PerformanceLink";
import { dateIsDark } from "../helpers/PerformanceLink";

export const monthlyDates = ( month, performances, today ) => {

    let yyyy = month.split('-')[0];
    let mm = month.split('-')[1];
    const daysInMonth = (year, month) => new Date(year, month, 0).getDate();

    let daysThisMonth = daysInMonth(yyyy, mm);
    let dayBlocks = '';

    // Loop to render blocks
    for (let index = 0; index < daysThisMonth; index++) {

        const numberedDay = index + 1;
        const fullPerformanceDate = yyyy + '-' + mm + '-' + (numberedDay > 9 ? numberedDay : '0' + numberedDay);
        let tempDate = new Date( Date.UTC(yyyy, mm -1, numberedDay) );
		const thisRenderedDate = new Date(tempDate.getTime() + (tempDate.getTimezoneOffset() * 60000)); // this is how we correct for the time zone problem April 1, 2024
		thisRenderedDate.setHours(23);
		thisRenderedDate.setMinutes(59);
		thisRenderedDate.setSeconds(59);

		// add classes
		var dayboxclasses = 'day-box';
		if (thisRenderedDate < today) {
			dayboxclasses += ' day-box-past';
		} else if (dateIsDark(thisRenderedDate, performances)) {
			dayboxclasses += ' day-box-dark';
		}
        
        dayBlocks += `<div class="`+dayboxclasses+`" data-performance-date="${fullPerformanceDate}"><div class="day-box-inner">`;
        dayBlocks += `<div class="box-date">${ renderFormattedDate(thisRenderedDate, limelight.data.monthly_date_format) }</div>`;
        if(thisRenderedDate >= today) {
            dayBlocks += `<div class="performance-holder">${ renderPerformanceLink(thisRenderedDate, performances )}</div>`;
        } else {
            dayBlocks += `<div class="performance-holder performance-holder--empty"></div>`;

        }
        dayBlocks += `</div></div>`;
    }

    return dayBlocks;

}